// Shared palette so every dashboard chart widget looks like one system
// instead of each picking its own colors. BRAND matches the maroon already
// used for the Export PDF/Excel buttons and print letterheads elsewhere in
// this app (#6E1423).
export const BRAND = "#6E1423";
export const CHART_COLORS = [BRAND, "#1B2A4A", "#2E7D32", "#F59E0B", "#6B7280", "#0EA5E9"];
